import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../../../../shared/services/custom/account.service';

declare let $;

@Component({
    selector: 'app-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss'],
    styles: [`.toggle-password {
		position: absolute;
    	right: 7px;
    	top: 9px;
		z-index: 10;
		cursor: pointer;
	}`]
})
export class AccountMenuComponent {
    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();
    user;

    loginForm: FormGroup;
    loading = false;

    constructor(private account: AccountService, private fb: FormBuilder) {
        account.user$.subscribe(user => {
            this.user = user;
        });
        this.loginForm = this.fb.group({
            'username': [null, Validators.required],
            'password': [null, Validators.required]
        });
    }

    togglePassword(ev) {
        $(ev.target).toggleClass("fa-eye fa-eye-slash");
        var input = $(ev.target).prev();
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
        return true;
    }

    logout() {
        this.account.logout();
        this.closeMenu.emit();
    }

    submit() {
        this.loginForm.markAllAsTouched();
        if (this.loginForm.invalid || this.loading)
            return;
        this.loading = true;
        let data = this.loginForm.value;
        this.account.login(data).subscribe(r => { this.loading = false; this.loginForm.reset() },
            error => {
                this.loading = false;
                if (error.error) {
                    let jsonError = error.error;
                    if (error.status == 403) {
                        if (jsonError.error_code == 1452005) {
                            this.loginForm.get('username').setErrors({
                                'emailNotExist': `Utente con email "${data['username']}" non esiste`
                            });
                            return;
                        }
                        if (jsonError.error_code == 1452008) {
                            this.loginForm.get('password').setErrors({
                                'passwordWrong': `Password errata`
                            });
                            return;
                        }
                    }
                    
                    if (jsonError.error_code == 3) {
                        this.loginForm.get('username').setErrors({
                            'emailNotExist': `Utente "${data['username']}" non esiste o password errata`
                        });
                        return;
                    }

                    if (jsonError.error_code == 2) {
                        this.loginForm.get('password').setErrors({
                            'passwordWrong': `Password errata`
                        });
                        return;
                    }
                }
                alert(JSON.stringify(error));
            }
        );
    }

    /**
    * Checking control validation
    *
    * @param controlName: string => Equals to formControlName
    * @param validationType: string => Equals to valitors name
    */
    isControlHasError(controlName: string): boolean | string {
        const control = this.loginForm.controls[controlName];
        if (!control || !control.touched) {
            return false;
        }
        if (control.errors) {
            if (control.errors['required']) {
                return 'Il campo è obbligatorio';
            }
            if (control.errors['email'])
                return 'Email non è valido';
            if (control.errors['emailNotExist'])
                return control.errors['emailNotExist'];
            if (control.errors['passwordWrong'])
                return control.errors['passwordWrong'];

            return 'Errore nella compilazione del campo';
        }
        return false;
    }
}
